import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { EFormService } from '../../../../shared-components/e-forms/e-form.service';
import { EFormStatusHistory } from '../../../../shared-components/e-forms/e-form-status-history.model';
import { EForm } from '../../../../shared-components/e-forms/e-form.model';
import { SendEmailService } from '../../../../shared-modules/send-email/send-email.service';
import { UserService } from '../../../../shared-components/user/user.service';
import { Router } from '@angular/router';
import { EFormContact } from '../../../../shared-components/e-forms/e-form-contact.model';
import { SendEmailComponent } from '../../../../shared-modules/send-email/send-email.component';
import { LoginService } from '../../../../shared-modules/login/login.service';

@Component({
	selector: 'app-e-form-mark-submission',
	templateUrl: './e-form-mark-submission.component.html',
	// styleUrls: ['./e-form-mark-submission.component.scss']
})
export class EFormMarkSubmissionComponent implements OnInit {

	banner: string;
	infoLine: string;
	commentHeader: string;
	newStatus: string;
	markType: string;
	emailNext: boolean;
	statusHistory: EFormStatusHistory;
	eForm: EForm;
	comment = '';
	sendEmailDialogRef: MatDialogRef<SendEmailComponent>;
	saveButtonClick: boolean;
	V10: boolean;
	hasFee = false;

	constructor(
		private dialogRef: MatDialogRef<EFormMarkSubmissionComponent>,
		private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private eFormService: EFormService,
		private sendEmailService: SendEmailService,
		private userService: UserService,
		private router: Router,
		private loginService: LoginService
	) {
		this.V10 = this.loginService.LoginSettings.V10;
		this.markType = this.data.markType;
		if (this.data.statusHistory) {
			this.statusHistory = this.data.statusHistory;
			this.comment = this.statusHistory.Comment;
		}
		if (this.data.eForm) {
			this.eForm = this.data.eForm;
		}
		if (this.data.hasFee) {
			this.hasFee = this.data.hasFee;
		}
	}

	ngOnInit() {
		this.banner = this.markType;

		switch (this.markType) {
			case 'Re-Open':
				this.infoLine = 'This submission will be re-opened, allowing the user to make changes and re-submit.';
				this.commentHeader = 'Comments regarding why this changes is being made:';
				// if (this.V10) {
					this.newStatus = 'Re-Opened';
				// }
				// else {
				// 	this.newStatus = 'Not Submitted';
				// }
				this.emailNext = true;
				break;
			case 'Mark Complete':
				this.infoLine = 'This submission will be marked as complete.';
				this.commentHeader = 'Comments regarding why this change is being made:';
				this.newStatus = 'Complete';
				this.emailNext = false;
				break;
			case 'Delete':
				this.infoLine = 'This submission will be marked as deleted.';
				this.commentHeader = 'Comments regarding why this change is being made:';
				// if (this.V10) {
					this.newStatus = 'Deleted';
				// }
				// else {
				// 	this.newStatus = this.eForm.AllowMultiple == false ? 'Not Submitted' : 'Deleted';
				// }
				this.emailNext = false;
				break;
			case 'Edit Submission History':
				this.infoLine = '';
				this.commentHeader = '';
				this.emailNext = false;
				break;
			case 'Rejected':
				this.banner = 'Reject';
				this.infoLine = 'This submission will be rejected, allowing the user to make changes and re-submit.';
				this.commentHeader = 'Comments regarding why this change is being made:';
				this.newStatus = 'Rejected';
				this.emailNext = true;
				break;
		}
	}

	nextClick() {
		if (this.markType == 'Re-Open') {
			this.eForm.Status = 'Re-Opened';
			this.eForm.ManualSubmission = false;
			// if (this.V10) {
				this.saveStatus(true);
			// }
			// else {
			// 	// Save with Re-Opened status to create record in status history, then save again with Not Submitted status
			// 	this.eFormService.saveEForm(this.eForm, this.comment).subscribe(result => {
			// 		this.eForm.Status = this.newStatus;
			// 		this.saveStatus(true);
			// 	});
			// }
		}
		else if (this.markType == 'Rejected') {
			this.saveButtonClick = false;
			this.eForm.Status = this.newStatus;
			this.saveStatus();
		}
		else {
			this.eForm.Status = this.newStatus;
			this.saveStatus(true);
		}
	}

	sendEmail() {
		this.eFormService.getEformContact(this.eForm.ID).subscribe(result => {
			const contact: EFormContact = result;
			const email: string = contact.Email;
			const name: string = contact.FirstName + ' ' + contact.LastName;

			if (contact.Email != null && contact.Email != '') {
				this.sendEmailService.teacherName = name;
				this.sendEmailService.teacherEmailAddress = email;
				this.sendEmailDialogRef = this.dialog.open(SendEmailComponent, {
					width: '80%',
					height: '80%',
					maxHeight: '80vh',
					maxWidth: '80vw',
					data: {
						modal: true,
						banner: 'Re-Open e-Form Submission'
					},
				});
				setTimeout(() => {
					let subject = '';
					if (this.eForm.TemplateType == 'student') {
						const lastIndex = this.eForm.StudentNames[0].indexOf('-');
						const studentname = this.eForm.StudentNames[0].substring(0, lastIndex - 1);
						subject =  this.eForm.InstanceName + ' - ' + studentname ;
					}
					else {
						subject = this.eForm.InstanceName;
					}
					this.sendEmailDialogRef.componentInstance.mailDetail.subject = subject;
				}, 100);
				this.sendEmailDialogRef.afterClosed().subscribe(() => {
					this.dialogRef.close(true);
				});
			}
			else if (this.markType == 'Re-Open' && !this.sendEmailService.teacherEmailAddress && !this.loginService.LoginSettings.V10) {
				this.dialogRef.close(true);
			}
		});
	}

	saveClick() {
		if (this.banner == 'Edit Submission History') {
			this.statusHistory.Comment = this.comment;
			this.eFormService.SaveEformStatusHistory(this.statusHistory).subscribe(result => {
				this.dialogRef.close();
			});
		}
		else {
			if (this.markType == 'Delete') {
				this.eForm.Status = 'Deleted';
				this.eForm.ManualSubmission = false;
				// if (this.V10) {
					this.saveStatus();
				// }
				// else {
				// 	// Save with Delete status to create record in status history, then save again with Not Submitted status
				// 	this.eFormService.saveEForm(this.eForm, this.comment).subscribe(result => {
				// 		this.eForm.Status = this.newStatus;
				// 		this.saveStatus();
				// 	});
				// }
			}
			else if (this.markType == 'Re-Open') {
				this.eForm.Status = 'Re-Opened';
				this.eForm.ManualSubmission = false;
				// if (this.V10) {
					this.saveStatus();
				// }
				// else {
				// 	this.eFormService.saveEForm(this.eForm, this.comment).subscribe(result => {
				// 		this.eForm.Status = this.newStatus;
				// 		this.saveStatus();
				// 	});
				// }
			}
			else if (this.markType == 'Rejected') {
				this.saveButtonClick = true;
				this.eForm.Status = this.newStatus;
				this.saveStatus();
			}
			else {
				this.eForm.Status = this.newStatus;
				this.saveStatus();
			}
		}
	}

	saveStatus(sendEmail: boolean = false) {
		this.eFormService.saveEForm(this.eForm, this.comment).subscribe(result => {
			if (sendEmail) {
				this.sendEmail();
			}
			else {
				if (!this.saveButtonClick && this.markType == 'Rejected') {
					this.dialogRef.close('SendMailTrue');
				}
				else if (this.saveButtonClick && this.markType == 'Rejected') {
					this.dialogRef.close('SendMailFalse');
				}
				else {
					this.dialogRef.close(true);
				}
			}
		});
	}

	closeClick() {
		this.dialogRef.close(false);
	}

}
